import { render, staticRenderFns } from "./ItemFilterDetectionLayout.vue?vue&type=template&id=b28a487e&scoped=true&"
import script from "./ItemFilterDetectionLayout.vue?vue&type=script&lang=js&"
export * from "./ItemFilterDetectionLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b28a487e",
  null
  
)

export default component.exports